import React, { ReactNode } from 'react';
import { Translate } from 'react-redux-i18n';
import Button from '../../common/Button';
import logo from '../../../img/logo-idnot.png';
import { ACTIVATION, CREATION } from '../../../routes';
import ChooseProfileButton from './ChooseProfileButton';
import notaire from '../../../img/intermediatePage/notaire.svg';
import collaborateur from '../../../img/intermediatePage/collaborateur.svg';
import apps from '../../../img/intermediatePage/applications_notariales.svg';
import security from '../../../img/intermediatePage/authentification_centralisee.svg';
import simplicity from '../../../img/intermediatePage/gestion_simplifiee.svg';
import creationApi from '../../../network/api/creationApi';
import CarrouselLogos from './CarrouselLogos';
import { getLinks } from '../../../network/api/links';
import Footer from '../../layout/Footer';

type State = {
  isSignUpAvailable: boolean,
};

class IntermediaryPage extends React.Component<State> {
  state: State = {
    isSignUpAvailable: false,
  };

  componentDidMount(): void {
    creationApi.isSignUpAvailable()
      .then(() => {
        this.setState({ isSignUpAvailable: true });
      })
      .catch(() => {
        this.setState({ isSignUpAvailable: false });
      });
  }

  render(): ReactNode {
    return (
      <div>
        <div className="activation-header">
          <div className="label-container">
            <div className="back-button">
              <a
                aria-label="Se connecter"
                href={getLinks().connectionLink}
              >
                <Button
                  type="secondary"
                  i18nKey="HEADER.CONNECTION"
                />
              </a>
            </div>
            <div className="main-content">
              <div>
                <img className="logo" src={logo} alt="logo" />
              </div>
              <div>
                <h3>
                  <Translate value="HEADER.GET_UNIQUE_ACCOUNT" />
                </h3>
                <div className="subtitle">
                  <Translate value="HEADER.UNIQUE_ACCOUNT" />
                </div>
              </div>
            </div>
            <div className="filler" />
          </div>
        </div>
        <div className="intermediary-content">
          <div>
            <div className="intermediary-section">
              <ChooseProfileButton
                title="INTERMEDIARY.NOTARY"
                label="INTERMEDIARY.ACTIVATE"
                img={notaire}
                goTo={ACTIVATION}
              />
              {this.state.isSignUpAvailable
          && (
            <ChooseProfileButton
              title="INTERMEDIARY.COLLABORATOR"
              label="INTERMEDIARY.CREATE"
              img={collaborateur}
              goTo={CREATION}
            />
          )}
            </div>
            <div className="intermediary-section column information">
              <h4>
                <Translate value="INTERMEDIARY.SECTION_TITLE1" />
              </h4>
              <div className="explications">
                <div className="explication">
                  <img src={apps} alt="Toutes mes applications notariales avec un seul compte" />
                  <Translate value="INTERMEDIARY.ONE_ACCOUNT" />
                </div>
                <div className="explication">
                  <img src={simplicity} alt="Une gestion simplifiée de mes données personnelles" />
                  <Translate value="INTERMEDIARY.SIMPLICITY" />
                </div>
                <div className="explication">
                  <img src={security} alt="Une authentification centralisée et sécurisée" />
                  <Translate value="INTERMEDIARY.SECURITY" />
                </div>
              </div>
            </div>
            <div className="intermediary-section column">
              <h4>
                <div className="title-background primary" />
                <Translate value="INTERMEDIARY.SECTION_TITLE2" />
              </h4>
              <CarrouselLogos />
            </div>
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}

export default IntermediaryPage;
